<template>
  <div class="link-wrap p-a t-a-c">
    <div class="d-i-b dl-gift">
      <a href="javascript:;" @click.prevent="cbtGift">
        <img :src="info.download_gift.src" alt="">
      </a>
    </div>
    <div class="d-i-b qrCode">
      <img :src="info.qrCode" alt="">
    </div>
    <div class="d-i-b dl-link">
      <a class="d-b google" href="javascript:;" @click.prevent="goGoogle">
        <img :src="info.google_download.src" alt="">
      </a>
      <a class="d-b app-store" href="javascript:;" @click.prevent="goAppStore">
        <img :src="info.app_stor_download.src" alt="">
      </a>
      <a class="d-b gift-btn" href="javascript:;">
        <img :src="info.btn_gift" alt="" @click.prevent="goToGitfLink">
      </a>
    </div>
  </div>
</template>
<style lang="less" scoped>
  .link-wrap {
    width: 100%;
    top: 10.5rem;
  }
  .dl-gift,
  .qrCode {
    width: 2.4rem;
    height: 2.4rem;
  }
  .qrCode {
    margin: 0 .1rem;
  }
  .app-store {
    margin: .15rem 0;
  }
  .dl-link {
    width: 4.56rem;
  }
  img {
    width: 100%;
  }
  @media screen and (min-width:1025px) {
    [pc="1"] .dl-gift,
    [pc="1"] .qrCode {
      width: 180px;
      height: 180px;
    }
    [pc="1"] .qrCode {
      margin: 0 20px;
    }
    [pc="1"] .link-wrap {
      top: 770px;
    }
    [pc="1"] .dl-link {
      width: 340px;
    }
    [pc="1"] .app-store {
      margin: 12px 0;
    }
  }
</style>

<script>
  import Util from "@util/index.js";
  export default {
    props: ['info', 'lan'],
    methods: {
      goToGitfLink() {
        console.log('领取礼包按钮')
        Util.trackGA('点击', this.lan + ':领取礼包按钮', this.lan + ':领取礼包按钮');
        if (this.info.gift_link) {
          window.location.href = this.info.gift_link;
        } else {
          alert(this.info.gift_alert_text);
        }
      },
      goAppStore() {
        console.log('AppStore下载按钮')
        Util.trackGA('点击', this.lan + ':AppStore下载按钮', this.lan + ':AppStore下载按钮');
        if (this.info.app_stor_download.url) {
          window.location.href = this.info.app_stor_download.url;
        } else {
          alert(this.info.app_stor_download.text)
        }
      },
      goGoogle() {
        console.log('google下载按钮')
        Util.trackGA('点击', this.lan + ':google下载按钮', this.lan + ':google下载按钮');
        window.location.href = this.info.google_download.url;
      },
      cbtGift() {
        console.log('cbt下载按钮')
        Util.trackGA('点击', this.lan + ':cbt下载按钮', this.lan + ':cbt下载按钮');
        window.location.href = this.info.download_gift.url;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/smsgz/components/index/downLoad.vue